<template>
  <div id="cat_top" @mouseenter="showNav(true,navItems.length)" @mouseleave="showNav(false)">
    <div class="title">
      <img src="img/category.svg" />
      <span>{{constant.allCategory}}</span>
    </div>
    <!--分类导航栏-->
    <div :style="style_cleft" class="c_left" v-show="isShowNav" id="left">
      <ul id="l_ul">
        <div v-for="(navItem,index) in navItems" :key="index">
          <li>
            <p>
              <span v-for="(levelOne, indexOne) in navItem" :key="indexOne">
                <a @click="searchByCat(levelOne)" :title="levelOne.name">{{levelOne.name}}</a>
                <span v-if="indexOne!=navItem.length-1">/</span>
              </span>
            </p>
          </li>
          <div :style="style_box" class="box" id="box">
            <div class="bx_a">
              <div v-for="(levelOne, indexOne) in navItem" :key="indexOne">
                <div
                  class="case2"
                  v-for="(levelTwo,indexTwo) in levelOne.children"
                  :key="indexTwo"
                  v-if="levelTwo.children.length>0"
                >
                  <a @click="searchByCat(levelTwo)">
                    <h5 :title="levelTwo.name">{{levelTwo.name}}&nbsp;&nbsp;&gt;</h5>
                  </a>
                  <div class="cs2_a">
                    <div>
                      <div v-for="(levelThree,indexThree) in levelTwo.children" :key="indexThree">
                        <i class="case_sp"></i>
                        <a
                          class="levelT"
                          @click="searchByCat(levelThree)"
                          :title="levelThree.name"
                        >{{levelThree.name}}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bx_b"></div>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["flexible"],
  data: function() {
    let nav = this.$store.state.malMainPageConfig.nav;
    let temp = nav.isShowAlways;
    //如果flexible为true,则配置文件中的isShowAlways会失效
    if (this.$props.flexible && this.$props.flexible === true) {
      temp = false;
    }
    return {
      isShowNav: temp,
      isShowAlways: temp,
      style_cleft: {
        minHeight: "452px",
        height: ""
      },
      style_box: {
        minHeight: "452px",
        height: ""
      },
      constant: this.$store.state.malMainPageConfig.constant
    };
  },
  computed: {
    navItems: function() {
      return this.$store.state.malMainPageConfig.nav.navItems;
    }
    // style_cleft:function(){
    //   return {
    //       minHeight: "452px",
    //       height:""
    //   }
    // },
    // style_box:function(){
    //   return {
    //       minHeight: "452px",
    //       height:""
    //   }
    // }
  },
  methods: {
    showNav(isShow, navLen) {
      if (this.isShowAlways) {
        //分类导航栏一直显示
        this.isShowNav = this.isShowAlways;
      } else {
        this.isShowNav = isShow;
      }
      //调整高度滑动栏最低高度
      // this.$nextTick(function(){
      //   if(navLen>14){
      //     var  heigth = 452 + (navLen-14)*30;
      //     this.style_box.minHeight = heigth +"px" ;
      //   }
      //   else{
      //     this.style_box.minHeight = "452px"
      //   }
      // })
      if (navLen > 14) {
        var heigth = 450 + (navLen - 14) * 30;
        this.style_box.minHeight = heigth + "px";
      } else {
        this.style_box.minHeight = "452px";
      }
    },
    searchByCat(navItem) {
      const base = window.location.href.split("/isv/")[0];
      let url = "";
      if (1 == this.$store.state.source) {
        url =
          base +
          "/index.html#/dform?formId=mal_search&source=1&searchText=" +
          navItem.longNumber +
          "&searchFields=['catlongnumber']&searchShowName=" +
          navItem.name +
          "&opentype=NewWindow";
      }
      if (2 == this.$store.state.source) {
        url =
          base +
          "/index.html#/dform?formId=mal_search&source=2&searchText=" +
          navItem.number +
          "&searchFields=['jdcatnumber']&searchShowName=" +
          navItem.name +
          "&opentype=NewWindow&isSearchByJDCatNum=1";
      }
      window.open(url, "_blank");
    }
  },
  created: function() {},
  mounted: function() {}
};
</script>

<style scoped lang="scss">
* {
  margin: 0;
  padding: 0;
}
div {
  display: block;
}
#cat_top .title {
  height: 44px;
  display: flex;
  align-items: center;
}
#cat_top .title img {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
#cat_top .title span {
  height: 44px;
  display: flex;
  align-items: center;
  font-size: 18px;
  width: 200px;
}
.content > ul > li {
  float: left;
  height: 44px;
  line-height: 44px;
  padding: 0 20px;
  font-size: 15px;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
}
.content li > a {
  color: black;
}
#cat_top {
  width: 200px;
  height: 44px;
  background-color: #f98354;
  color: #fff;
  padding: 0 10px;
}
.c_left {
  width: 220px;
  min-height: 452px;
  background-color: #6e6568;
  font-size: 14px;
  color: #fff;
  position: relative;
  right: 10px;
  z-index: 3000;
}
.c_left a {
  padding: 0 2px;
  cursor: pointer;
}

.c_left ul {
  padding: 15px 0;
}
.c_left li {
  width: 210px;
  height: 20px;
  padding: 5px 0 5px 10px;
  position: relative;
}
.c_left li:hover + .box {
  display: block;
}
.c_left .box:hover {
  display: block;
}
.c_left li p {
  float: left;
  width: 190px;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  position: absolute;
}
/*轮播图左边第一个二级菜单*/
.c_left .box {
  float: left;
  width: 980px;
  min-height: 450px;
  position: absolute;
  left: 220px;
  top: 0px;
  background-color: #6e6568;
  z-index: 3000;
  font-size: 12px;
  display: none;
}
.c_left .box .bx_a .case1 a {
  padding: 3px 10px;
  margin-right: 7px;
  background-color: #6e6568;
}
.c_left .box .bx_a .case1 a:hover {
  background-color: #5c5251;
}
.c_left .box .bx_a .case2 a {
  float: left;
  height: 30px;
  line-height: 30px;
  padding: 0 7px 0 0;
}
.c_left .box .bx_a .case2 a:hover {
  color: #c94e4a;
}
/*轮播图左边第一个二级菜单END*/
.c_left li:hover {
  background-color: #999395;
}
.c_left p a:hover {
  color: #c81623;
}
.case1 {
  width: 775px;
  height: 30px;
  line-height: 30px;
}
.bx_a {
  float: left;
  overflow: hidden;
  padding: 15px 20px;
}
.c_left .box .bx_a .case1 a {
  padding: 3px 10px;
  margin-right: 7px;
  background-color: #6e6568;
}
.cs2_a {
  width: 800px;
  float: left;
  border-bottom: 1px solid #eeeeee;
  margin-left: 10px;
  overflow: hidden;
}
.case_sp {
  float: left;
  width: 1px;
  height: 16px;
  background-color: #e0e0e0;
  margin: 7px 7px 0 0;
}
.c_left .box .bx_a .case2 h5 {
  width: 70px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.levelT {
  width: 60px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
